"use strict";

// eslint-disable-next-line @eslint-react/hooks-extra/ensure-custom-hooks-using-other-hooks
export function useBackButton(_) {
  // No-op
  // BackHandler is not available on web
}
//# sourceMappingURL=useBackButton.js.map